import * as React from "react";
import type { SVGProps } from "react";
const SvgFilter = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2.178 3h19.644l-.978 1.537-6.066 9.532v4.771l-.553.277-3.556 1.777-1.447.724v-7.549l-.844-1.327a1 1 0 1 1 1.687-1.074l1 1.573.157.246v4.895l1.556-.778v-4.117l.156-.246L18.178 5H5.822L7.91 8.282a1 1 0 1 1-1.687 1.073L3.156 4.537z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgFilter;
